import React from 'react';

const getInitials = (name) => {
  return name
    .split(' ')
    .filter(part => part !== 'Dr.')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 3);
};

const AVATAR_COLORS = [
  'bg-indigo-100 text-indigo-700',
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
  'bg-sky-100 text-sky-700',
];

const ContributorItem = ({ name, specialty, jobRole, contributions, avatarUrl, index = 0 }) => {
  const colorClass = AVATAR_COLORS[index % AVATAR_COLORS.length];
  const initials = getInitials(name || 'Doctor');
  const displayRole = jobRole || specialty || 'Veterinarian';

  return (
    <div className="flex items-center justify-between py-2 group">
      <div className="flex items-center gap-2.5">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold overflow-hidden ${colorClass}`}>
          {avatarUrl ? (
            <img src={avatarUrl} alt={name} className="w-full h-full object-cover" />
          ) : (
            initials
          )}
        </div>
        <div>
          <p className="text-sm font-medium text-text-black leading-tight">{name}</p>
          <p className="text-xs text-indigo-600 font-medium leading-tight">{displayRole}</p>
        </div>
      </div>
      <span className="text-sm font-semibold text-text-black">{contributions}</span>
    </div>
  );
};

export default ContributorItem;